import { EmployeeWithCompany } from "@/store/apis/employeeApi";
import { createSlice } from "@reduxjs/toolkit";

export type HREmployee = EmployeeWithCompany & {
  phone_unlocked?: boolean;
  email_unlocked?: boolean;
};

export type HR = {
  hrMap: HREmployee[];
};

const initialState: HR = {
  hrMap: [],
};

export const hrSlice = createSlice({
  name: "hr",
  initialState,
  reducers: {
    setHREmployees: (state, action: { payload: HREmployee[] }) => {
      state.hrMap = action.payload;
    },
    addHREmployee: (state, action: { payload: HREmployee }) => {
      state.hrMap.push(action.payload);
    },
    safeAddHREmployee: (state, action: { payload: HREmployee }) => {
      const existingEmployee = state.hrMap.find((emp) => emp.employee_id === action.payload.employee_id);
      if (!existingEmployee) {
        state.hrMap.push(action.payload);
      }
    },
    clearHREmployees: () => {
      return initialState;
    },
  },
});

export const { setHREmployees, addHREmployee, clearHREmployees, safeAddHREmployee } = hrSlice.actions;
